import { Component, Input, Injectable, OnInit } from '@angular/core';

@Component({
    selector: 'alert-box',
    template: require('./AlertBoxComponent.html'),
    styles: [require('./AlertBoxComponent.sass')]
})

@Injectable()
export class AlertBoxComponent implements OnInit {
    @Input('message') message: string;
    @Input('type') type: string;

    ngOnInit() {
        // Set default message type if no type input received.
        if(!this.type) {
            this.type = "warning";
        }
    }

    onClose() {
        // Set message to "" to hide the box.
        this.message = "";
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/shared/components/alert-box/AlertBoxComponent.ts